//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class LogsUrlConstants
{
	public static logErrorUrl: string = `/api/Logs/LogError`;
}
